import { useEffect } from "react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { FAQ } from "@/components/site/FAQ";

export default function FAQPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white">
      <Header />
      <main className="pt-24 lg:pt-28">
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
